import { createSlice } from '@reduxjs/toolkit';

import getCustomerDeviceType from 'editor/src/util/getCustomerDeviceType';

import popupInitialState from './module/popup/initialState';
import openPopupReducer from './module/popup/reducer/openPopupReducer';
import addLoaderReducer from './reducer/addLoaderReducer';
import removeLoaderReducer from './reducer/removeLoaderReducer';
import setActiveAddLayerDropdownReducer from './reducer/setActiveAddLayerDropdownReducer';
import setActiveTopMenuDropdownReducer from './reducer/setActiveTopMenuDropdownReducer';
import setCustomerDeviceTypeReducer from './reducer/setCustomerDeviceTypeReducer';
import setMobileViewReducer from './reducer/setMobileViewReducer';
import setMultiTechAreaGroupsReducer from './reducer/setMultiTechAreaGroupsReducer';
import setMultiTechModeReducer from './reducer/setMultiTechModeReducer';
import setSelectedTechForAreaReducer from './reducer/setSelectedTechForAreaReducer';
import setShowRealisticPreviewReducer from './reducer/setShowRealisticPreviewReducer';
import setSimpleDropdownReducer from './reducer/setSimpleDropdownReducer';
import showActionBarReducer from './reducer/showActionBarReducer';
import { AppState } from './types';

export const appInitialState: AppState = {
  dropdowns: {
    activeAddLayerDropdown: undefined,
    activeTopMenuDropdown: undefined,
    mobileMoreMenuDropdown: undefined,
  },
  simpleDropdown: {
    name: undefined,
    data: undefined,
  },
  customerDeviceType: getCustomerDeviceType(),
  activeActionBar: undefined,
  popup: popupInitialState,
  activeLoaders: {},
  mobileView: 'spreads',
  showRealisticPreview: true,
};

export const slice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    setActiveTopMenuDropdownAction: setActiveTopMenuDropdownReducer,
    setActiveAddLayerDropdownAction: setActiveAddLayerDropdownReducer,
    setCustomerDeviceTypeAction: setCustomerDeviceTypeReducer,
    showActionBarAction: showActionBarReducer,
    setSimpleDropdownAction: setSimpleDropdownReducer,
    openPopupAction: openPopupReducer,
    addLoaderAction: addLoaderReducer,
    removeLoaderAction: removeLoaderReducer,
    setMobileViewAction: setMobileViewReducer,
    setShowRealisticPreviewAction: setShowRealisticPreviewReducer,
    setMultiTechModeAction: setMultiTechModeReducer,
    setMultiTechAreaGroupsAction: setMultiTechAreaGroupsReducer,
    setSelectedTechForAreaAction: setSelectedTechForAreaReducer,
  },
});

export const {
  setActiveTopMenuDropdownAction,
  setActiveAddLayerDropdownAction,
  setCustomerDeviceTypeAction,
  showActionBarAction,
  setSimpleDropdownAction,
  openPopupAction,
  addLoaderAction,
  removeLoaderAction,
  setMobileViewAction,
  setShowRealisticPreviewAction,
  setMultiTechModeAction,
  setMultiTechAreaGroupsAction,
  setSelectedTechForAreaAction,
} = slice.actions;

export default slice.reducer;
